import { useEffect } from 'react';

import {
  useUserJobProspectsState,
  useUserJobProspectsActions
} from './UserJobProspectsContext';

import {
  getUserJobProspects,
} from './restApi';

const UserJobProspectsLoader = () => {
  const state = useUserJobProspectsState();
  const { initializeState, onResponse, onError } = useUserJobProspectsActions();

  const userId = state?.userId;

  useEffect(() => {
    if (!userId) return;

    getUserJobProspects({
      userId,
      onResponse,
      onError,
    });
  }, [userId]);

  return null;
};

export default UserJobProspectsLoader;
